/**
 * This file was automatically generated by `IconCodeGenerator`.
 * DO NOT MODIFY IT BY HAND. Instead, follow the instructions at `src/shared/joykit/packages/core/icons/README.md`.
 */

import * as React from 'react';

import createSvgIcon from '../createSvgIcon';

import { SvgIconConfig } from '../types';

const config: SvgIconConfig = {
  title: 'Star Half Filled',
  definitions: {
    '16': {
      viewBox: '0 0 16 16',
      path: (
        <>
          <path
            d="M4.94077 9.7365L0.475369 6.50638C0.402491 6.4538 0.371719 6.36014 0.399482 6.27471C0.427136 6.18918 0.506849 6.1314 0.596754 6.1315L6.10882 6.14213L7.80117 0.898558C7.82872 0.812914 7.90843 0.754916 7.99834 0.754916L7.99936 0.754883L7.99946 11.9581L3.54655 15.2052C3.47389 15.2581 3.37541 15.2581 3.30275 15.2053C3.22999 15.1525 3.19962 15.0588 3.22749 14.9734L4.94077 9.7365Z"
            fill="currentColor"
          />{' '}
          <path
            d="M11.0583 9.7365L15.5237 6.50638C15.5965 6.4538 15.6273 6.36014 15.5995 6.27471C15.5719 6.18918 15.4922 6.1314 15.4023 6.1315L9.8902 6.14213L8.19785 0.898558C8.1703 0.812914 8.09059 0.754916 8.00069 0.754916L7.99966 0.754883L7.99957 11.9581L12.4525 15.2052C12.5251 15.2581 12.6236 15.2581 12.6963 15.2053C12.769 15.1525 12.7994 15.0588 12.7715 14.9734L11.0583 9.7365Z"
            fill="#EBEBEB"
          />
        </>
      ),
    },
  },
};

const icon = createSvgIcon(config);
export default icon;
